import Menu from './Compartido/Menu.jsx';
import ListaNoticias from './ListaBlog/ListaNoticias.jsx';
import Footer from './Compartido/Footer.jsx';

const ListaBlog = (props) => {

    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.config}
                ruta={props.ruta}
            />
            <ListaNoticias
                noticias={props.noticias}
                ruta={props.ruta}
                lang={props.lang}
                config={props.websgrupo}
            />
            <Footer
                datos={props.websgrupo}
                config={props.config}
                lang={props.lang}
                ruta={props.ruta}
            />
        </main>
    );
}

export default ListaBlog;
